:host {
  display: block;
}

.success-message-h2 {
  font-weight: bold;
  margin-top: 38px;
  margin-bottom: 38px;
  margin-left: 25px;
}

.success-message-h4 {
  font-weight: bold;
  margin-bottom: 40px;
  margin-left: 25px;
}

.success-message-p {
  margin-bottom: 70px;
  margin-left: 25px;
  margin-right: 25px;
}

.error-message-h2 {
  font-weight: bold;
  margin-bottom: 40px;
  margin-left: 25px;
}

.error-message-h4 {
  font-weight: bold;
  margin-bottom: 40px;
  margin-left: 25px;
}

.error-message-p {
  margin: -10px 25px;
}

.error-message-list {
  margin-left: 10px;
  margin-bottom: 40px;
}

.error-message-button {
  padding: 8px 20px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 25px;
  font-family: 'MarkOffcForMC', serif;
  font-weight: bold;
  margin-left: 25px;
  border: 1.5px solid #000;
}

.error-message-button:hover {
  cursor: pointer;
}

form {
  h2 {
    margin-bottom: 20px;
  }
  h4 {
    margin-bottom: 36px;
  }

  .forms-ui-consents {
    margin-top: 48px;
    margin-bottom: 72px;
  }

  .forms-ui-explicit-consent,
  .forms-ui-implicit-consent,
  .forms-ui-form-element.checkbox
  {
    margin-bottom: 24px;
  }

  .forms-ui-form-element
  {
    margin-bottom: 16px;
  }

  .forms-ui-form-element.hidden {
    margin-bottom: 0px;
  }
}